export const EXPLICIT_HINT = 'Нецензурная лексика';
export const PROMO_LABEL = 'Промо';
export const REMOVE_ADDS = 'Удалить ролик';
export const RETRY_ADDS = 'Повторить загрузку';
